import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const DrumTower = {
  id: "74",
  name: "Drum Tower",
  width: 4,
  height: 4,
  type: BuildingType.EVENT,
  era: "stoneAge",
  icon: "Drum_Tower",
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Drum_Tower',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asPerLevel([
        0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3,
        3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5,
        5, 5, 5, 5, 6, 6, 6, 6, 6, 6,
      ]),
    ),
    new CultureBonus(
      CultureAmount.asPerEraAndLevel({
        stoneAge: [
          15, 15, 15, 25, 25, 25, 40, 40, 50, 50, 55, 55, 60, 60, 65, 65, 70, 70,
          75, 75, 80, 80, 85, 85, 90, 90, 95, 95, 100, 100, 105, 105, 110, 110,
          115, 115, 120, 120, 125, 206, 209, 212, 215, 218, 221, 224, 227, 230,
          233, 236, 239, 242, 245, 248, 251, 254, 257, 260, 263, 266,
        ],
        bronzeAge: [
          20, 20, 20, 50, 50, 50, 80, 80, 90, 90, 100, 100, 110, 110, 120, 120,
          130, 130, 140, 140, 150, 150, 160, 160, 170, 170, 180, 180, 185, 185,
          190, 190, 200, 200, 210, 210, 220, 220, 230, 235, 240, 245, 250, 255,
          260, 265, 270, 275, 280, 285, 290, 295, 300, 305, 310, 315, 320, 325,
          330, 335,
        ],
        minoanEra: [
          30, 30, 30, 75, 75, 75, 120, 120, 135, 135, 150, 150, 165, 165, 180,
          180, 195, 195, 210, 210, 225, 225, 240, 240, 255, 255, 270, 270, 280,
          280, 285, 285, 300, 300, 315, 315, 330, 330, 345, 353, 361, 369, 377,
          385, 393, 401, 409, 417, 425, 433, 441, 449, 457, 465, 473, 481, 489,
          497, 505, 513,
        ],
        classicGreece: [
          40, 40, 40, 90, 90, 90, 150, 150, 170, 170, 180, 180, 200, 200, 220,
          220, 240, 240, 260, 260, 270, 270, 290, 290, 310, 310, 330, 330, 340,
          340, 350, 350, 360, 360, 380, 380, 400, 400, 420, 430, 440, 450, 460,
          470, 480, 490, 500, 510, 520, 530, 540, 550, 560, 570, 580, 590, 600,
          610, 620, 630,
        ],
        earlyRome: [
          50, 50, 50, 120, 120, 120, 200, 200, 220, 220, 240, 240, 270, 270, 290,
          290, 320, 320, 340, 340, 360, 360, 390, 390, 410, 410, 440, 440, 450,
          450, 460, 460, 480, 480, 510, 510, 530, 530, 560, 574, 588, 602, 616,
          630, 644, 658, 672, 686, 700, 714, 728, 742, 756, 770, 784, 798, 812,
          826, 840, 854,
        ],
        romanEmpire: [
          60, 60, 60, 140, 140, 140, 230, 230, 260, 260, 270, 270, 300, 300, 330,
          330, 360, 360, 390, 390, 410, 410, 440, 440, 470, 470, 500, 500, 510,
          510, 530, 530, 540, 540, 570, 570, 600, 600, 630, 646, 662, 678, 694,
          710, 726, 742, 758, 774, 790, 806, 822, 838, 854, 870, 886, 902, 918,
          934, 950, 966,
        ],
        byzantineEra: [
          70, 70, 70, 150, 150, 150, 240, 240, 270, 270, 290, 290, 330, 330, 350,
          350, 390, 390, 410, 410, 440, 440, 470, 470, 500, 500, 530, 530, 540,
          540, 560, 560, 580, 580, 620, 620, 640, 640, 680, 697, 714, 731, 748,
          765, 782, 799, 816, 833, 850, 867, 884, 901, 918, 935, 952, 969, 986,
          1003, 1020, 1037,
        ],
        ageOfTheFranks: [
          80, 80, 80, 170, 170, 170, 280, 280, 320, 320, 330, 330, 360, 360, 400,
          400, 440, 440, 470, 470, 500, 500, 530, 530, 570, 570, 600, 600, 620,
          620, 640, 640, 650, 650, 690, 690, 720, 720, 760, 779, 798, 817, 836,
          855, 874, 893, 912, 931, 950, 969, 988, 1007, 1026, 1045, 1064, 1083,
          1102, 1121, 1140, 1159,
        ],
        feudalAge: [
          90, 90, 90, 180, 180, 180, 290, 290, 330, 330, 350, 350, 400, 400, 420,
          420, 470, 470, 500, 500, 530, 530, 570, 570, 600, 600, 640, 640, 650,
          650, 680, 680, 700, 700, 750, 750, 770, 770, 820, 841, 862, 883, 904,
          925, 946, 967, 988, 1009, 1030, 1051, 1072, 1093, 1114, 1135, 1156,
          1177, 1198, 1219, 1240, 1261,
        ],
        iberianEra: [
          100, 100, 100, 210, 210, 210, 340, 340, 390, 390, 400, 400, 440, 440,
          480, 480, 530, 530, 570, 570, 600, 600, 640, 640, 690, 690, 720, 720,
          750, 750, 770, 770, 780, 780, 830, 830, 870, 870, 920, 943, 966, 989,
          1012, 1035, 1058, 1081, 1104, 1127, 1150, 1173, 1196, 1219, 1242, 1265,
          1288, 1311, 1334, 1357, 1380, 1403,
        ],
        kingdomOfSicily: [
          110, 110, 110, 220, 220, 220, 350, 350, 400, 400, 420, 420, 480, 480,
          510, 510, 570, 570, 600, 600, 640, 640, 690, 690, 720, 720, 770, 770,
          790, 790, 820, 820, 840, 840, 900, 900, 930, 930, 990, 1015, 1040, 1065,
          1090, 1115, 1140, 1165, 1190, 1215, 1240, 1265, 1290, 1315, 1340, 1365,
          1390, 1415, 1440, 1465, 1490, 1515,
        ],
        highMiddleAges: [
          120, 120, 120, 260, 260, 260, 410, 410, 470, 470, 480, 480, 530, 530,
          580, 580, 640, 640, 690, 690, 720, 720, 770, 770, 830, 830, 870, 870,
          900, 900, 930, 930, 940, 940, 1000, 1000, 1050, 1050, 1110, 1138, 1166,
          1194, 1222, 1250, 1278, 1306, 1334, 1362, 1390, 1418, 1446, 1474, 1502,
          1530, 1558, 1586, 1614, 1642, 1670, 1698,
        ],
        earlyGothicEra: [
          122, 122, 122, 267, 267, 267, 422, 422, 485, 485, 498, 498, 551, 551,
          604, 604, 668, 668, 721, 721, 754, 754, 807, 807, 870, 870, 914, 914,
          947, 947, 980, 980, 993, 993, 1065, 1065, 1110, 1110, 1173, 1200, 1230,
          1260, 1290, 1320, 1350, 1380, 1410, 1440, 1470, 1500, 1530, 1560, 1590,
          1620, 1650, 1680, 1710, 1740, 1770, 1800,
        ],
        lateGothicEra: [
          0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0
        ]
      }),
      CultureRange.asPerLevel([
        1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3,
        3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
        6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
      ]),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,60,60,60,60,75,75,75,75,90,90,105,105,105,105,120,120,120,120,150,150,180,180,180,180,210,210,210,210,240,240,270,270,270,270,300,300,300,300,330,338,346,354,362,370,378,386,394,402,410,418,426,434,442,450,458,466,474,482,490
        ],
        bronzeAge: [
          0,90,90,90,90,113,113,113,113,135,135,158,158,158,158,180,180,180,180,225,225,270,270,270,270,315,315,315,315,360,360,405,405,405,405,450,450,450,450,495,507,519,531,543,555,567,579,591,603,615,627,639,651,663,675,687,699,711,723,735
        ],
        minoanEra: [
          0,108,108,108,108,135,135,135,135,162,162,189,189,189,189,216,216,216,216,270,270,324,324,324,324,378,378,378,378,432,432,486,486,486,486,540,540,540,540,594,608,622,636,650,664,678,692,706,720,734,748,762,776,790,804,818,832,846,860,874
        ],
        classicGreece: [
          0,162,162,162,162,204,204,204,204,243,243,285,285,285,285,324,324,324,324,405,405,486,486,486,486,567,567,567,567,648,648,729,729,729,729,810,810,810,810,891,913,935,957,979,1001,1023,1045,1067,1089,1111,1133,1155,1177,1199,1221,1243,1265,1287,1309,1331
        ],
        earlyRome: [
          0,195,195,195,195,243,243,243,243,292,292,341,341,341,341,389,389,389,389,486,486,584,584,584,584,681,681,681,681,778,778,875,875,875,875,972,972,972,972,1070,1096,1122,1148,1174,1200,1226,1252,1278,1304,1330,1356,1382,1408,1434,1460,1486,1512,1538,1564,1590
        ],
        romanEmpire: [
          0,210,210,210,210,260,260,260,260,310,310,360,360,360,360,410,410,410,410,510,510,610,610,610,610,710,710,710,710,810,810,920,920,920,920,1020,1020,1020,1020,1120,1148,1176,1204,1232,1260,1288,1316,1344,1372,1400,1428,1456,1484,1512,1540,1568,1596,1624,1652,1680
        ],
        byzantineEra: [
          0,210,210,210,210,260,260,260,260,310,310,360,360,360,360,410,410,410,410,510,510,610,610,610,610,710,710,710,710,810,810,920,920,920,920,1020,1020,1020,1020,1120,1148,1176,1204,1232,1260,1288,1316,1344,1372,1400,1428,1456,1484,1512,1540,1568,1596,1624,1652,1680
        ],
        ageOfTheFranks: [
          0,210,210,210,210,260,260,260,260,310,310,360,360,360,360,410,410,410,410,510,510,610,610,610,610,710,710,710,710,810,810,920,920,920,920,1020,1020,1020,1020,1120,1148,1176,1204,1232,1260,1288,1316,1344,1372,1400,1428,1456,1484,1512,1540,1568,1596,1624,1652,1680
        ],
        feudalAge: [
          0,210,210,210,210,260,260,260,260,310,310,360,360,360,360,410,410,410,410,510,510,610,610,610,610,710,710,710,710,810,810,920,920,920,920,1020,1020,1020,1020,1120,1148,1176,1204,1232,1260,1288,1316,1344,1372,1400,1428,1456,1484,1512,1540,1568,1596,1624,1652,1680
        ],
        iberianEra: [
          0,210,210,210,210,260,260,260,260,310,310,360,360,360,360,410,410,410,410,510,510,610,610,610,610,710,710,710,710,810,810,920,920,920,920,1020,1020,1020,1020,1120,1148,1176,1204,1232,1260,1288,1316,1344,1372,1400,1428,1456,1484,1512,1540,1568,1596,1624,1652,1680
        ],
        kingdomOfSicily: [
          0,210,210,210,210,260,260,260,260,310,310,360,360,360,360,410,410,410,410,510,510,610,610,610,610,710,710,710,710,810,810,920,920,920,920,1020,1020,1020,1020,1120,1148,1176,1204,1232,1260,1288,1316,1344,1372,1400,1428,1456,1484,1512,1540,1568,1596,1624,1652,1680
        ],
        highMiddleAges: [
          0,210,210,210,210,260,260,260,260,310,310,360,360,360,360,410,410,410,410,510,510,610,610,610,610,710,710,710,710,810,810,920,920,920,920,1020,1020,1020,1020,1120,1148,1176,1204,1232,1260,1288,1316,1344,1372,1400,1428,1456,1484,1512,1540,1568,1596,1624,1652,1680
        ],
        earlyGothicEra: [
          0,210,210,210,210,260,260,260,260,310,310,360,360,360,360,410,410,410,410,510,510,610,610,610,610,710,710,710,710,810,810,920,920,920,920,1020,1020,1020,1020,1120,1148,1176,1204,1232,1260,1288,1316,1344,1372,1400,1428,1456,1484,1512,1540,1568,1596,1624,1652,1680
        ],
        lateGothicEra: [
          0,210,210,210,210,260,260,260,260,310,310,360,360,360,360,410,410,410,410,510,510,610,610,610,610,710,710,710,710,810,810,920,920,920,920,1020,1020,1020,1020,1120,1148,1176,1204,1232,1260,1288,1316,1344,1372,1400,1428,1456,1484,1512,1540,1568,1596,1624,1652,1680
        ]
      }).withOutput(ProductionOutputType.CURRENT_ERA_SECONDARY_GOODS),
    ),
  ]),
};

export default DrumTower;
